import { Typography } from "@mui/material";

export default function CaseAccordionSummary({ accordionItem }) {
  return (
    <Typography
      className={`${accordionItem?.expandedAccordions.includes(accordionItem?.index) ? "font-bold" : "font-normal"} text-md`}
    >
      {accordionItem.data.name}
    </Typography>
  );
}
